// ABOUTME: Mock data for Rusada → TechLog scheduled maintenance item transformation testing.
import type { RusadaToTechlogScheduledMxItemInput } from './validation';

/**
 * Mock scheduled maintenance item from Rusada API.
 * Based on real API response structure from phase 1 API investigation.
 */
export const mockRusadaScheduledMaintenance = {
  id: 102434,
  mi: 'PHE-29-0003',
  lifeCode: 'FLIGHT HOURS',
  currentLife: '3370:55 FH',
  remaining: '42:45 FH',
  life: '1600:00 FH',
  nextDue: '3413:40 FH',
  dueDate: '2025-12-16T00:00:00',
  workOrderId: null,
  workOrderNo: '',
  title: 'Restoration (Overhaul) of Hydraulic Powerpack Electrical Motor',
  componentAssetId: 4767,
  lastModified: '2025-11-25T22:36:04.463',
};

/**
 * Mock Rusada registration.
 */
export const mockRusadaRegistration = {
  id: 5,
  assetId: 3,
  registration: 'ZM335',
  statusId: 1,
  status: 'ACTIVE',
  serialNo: '12345',
  operator: 'AFF',
  isLocked: false,
};

/**
 * Mock TechLog aircraft.
 */
export const mockTechlogAircraft = {
  id: 'tl-aircraft-001',
  operatorId: 'op-001',
  aircraftTypeId: 'type-001',
  serialNumber: 'MSN12345',
  registration: 'ZM335',
  year: 2020,
  fuelUnit: 'kg',
  oilUnit: 'ml',
  maxFuelValue: 5000,
  monthlyCycles: 50,
  monthlyFlightSeconds: 180000,
  monthlyApuSeconds: 0,
  maintenanceType: 'hours',
  apuMode: 'notInstalled',
  flightStatus: 'onGround',
  createdAt: '2024-01-15T10:00:00Z',
  updatedAt: '2025-02-01T14:30:00Z',
};

/**
 * Complete mock input for transformation testing.
 */
export const mockData: RusadaToTechlogScheduledMxItemInput = {
  rusada: {
    scheduledMaintenance: mockRusadaScheduledMaintenance,
    registration: mockRusadaRegistration,
    parsedNextDue: { value: 3413 + 40 / 60, unit: 'FH', isOverdue: false },
  },
  techlog: {
    aircraft: mockTechlogAircraft,
  },
};

/**
 * Additional mock items for testing various lifeCode types.
 */
export const mockScheduledMaintenanceItems = {
  flightHours: {
    ...mockRusadaScheduledMaintenance,
    id: 1,
    lifeCode: 'FLIGHT HOURS',
    remaining: '42:45 FH',
    nextDue: '3413:40 FH',
  },
  days: {
    ...mockRusadaScheduledMaintenance,
    id: 2,
    lifeCode: 'DAYS',
    remaining: '-27DY',
    nextDue: '2025-10-30',
  },
  months: {
    ...mockRusadaScheduledMaintenance,
    id: 3,
    lifeCode: 'MONTHS',
    remaining: '0MO  -26Days',
    nextDue: '2025-10-31',
  },
  totalLandings: {
    ...mockRusadaScheduledMaintenance,
    id: 4,
    lifeCode: 'TOTAL LANDINGS',
    remaining: '259FL',
    nextDue: '8370FL',
  },
  engineCycles: {
    ...mockRusadaScheduledMaintenance,
    id: 5,
    lifeCode: 'ENGINE CYCLES',
    remaining: '1168EC',
    nextDue: '3000EC',
  },
  engineHours: {
    ...mockRusadaScheduledMaintenance,
    id: 6,
    lifeCode: 'ENGINE HOURS',
    remaining: '294:10 EH',
    nextDue: '1724:30 EH',
  },
  engineStarts: {
    ...mockRusadaScheduledMaintenance,
    id: 7,
    lifeCode: 'Engine Starts',
    remaining: '285ES',
    nextDue: '2854ES',
  },
  byDate: {
    ...mockRusadaScheduledMaintenance,
    id: 8,
    lifeCode: 'BY DATE',
    remaining: '107Days',
    nextDue: '2026-03-13',
  },
};
